var ServiceBundlingPayment = (function($) {
  var self = {};

  self.init = function() {
    setupPaymentMethodButtons();
  }

  function setupPaymentMethodButtons() {
    var selector = '.payment-option button[data-submit-url]';

    $(selector).click(paymentMethodHandler);
    $(selector).keypress(function (e) {
      var key = e.which;
      if(key == 13 || key == 32) { // Enter or space
        $(this).click();
      }
    });
  }

  function paymentMethodHandler() {
    var $form = $(this).parents("form");
    var $formSubmitButton = $form.children('input[type="submit"]');
    var submitUrl = $(this).data('submit-url');

    $form.attr('action', submitUrl);
    $formSubmitButton.click();

    return false;
  }

  return self;
}(jQuery))

$(document).ready(function() {
  ServiceBundlingPayment.init();
})
